import { useState } from "react";
import Form from "@/components/common/form/form";
import { authServices } from "services/auth.services";
import Model from "@/components/common/model.component";
import FlowMeterForm from "./flowMeterForm";
import LocationModal from "./editLocationModal";
import { WaterFlowService } from "services/assets-flowMeter.sevices";
import { useTranslation } from "react-i18next";
import _objI from "@/utils/_objI";
import Loader from "@/components/common/loader.components";
import PageTitle from "components/common/page-title.component";

const EditWaterSource = ({
  type,
  showModal,
  setShowModal,
  rowData,
  setRowData,
  setRefresh,
}) => {
  const [showLocationModal, setLocationModal] = useState(false);

  const { t } = useTranslation();
  const onSubmit = async (data) => {
    data.content_type =
      type === "tree"
        ? authServices.userValue.content_types
            ?.filter?.((items) => items.model === "treefieldinfo")
            ?.find?.((item) => item).id
        : authServices.userValue.content_types
            ?.filter?.((items) => items.model === "pivotfieldinfo")
            ?.find((item) => item).id;
    data.farm_id = Number(data.farm_id);
    data.object_id = Number(data.object_id);
    data.attributes_value.diameter_mm = Number(
      data.attributes_value.diameter_mm
    );
    data.attributes_value.current_reading = Number(
      data.attributes_value.current_reading
    );
    data.supplier_id = Number(data.supplier_id) || null;
    data.org_id = authServices.userValue.org_id;
    data.entity_type_id = 5;

    let res = await WaterFlowService.editWaterFlow(data, rowData.id);
    if (res) {
      setLocationModal(true);
    }
  };
  if (!rowData || !type) {
    return <Loader />;
  }
  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-130"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
            setRowData({});
          }}
        >
          <PageTitle title={t("EditWaterSource")} titletextSize="text-xl" />

          <Form
            onSubmit={onSubmit}
            defaultValues={_objI(rowData) ? { ...rowData } : { ...rowData }}
          >
            <FlowMeterForm type={type} RowData={rowData} passProps icon={""} />
          </Form>
        </Model>
        <LocationModal
          setRefresh={setRefresh}
          showModal={showLocationModal}
          setShowModal={setLocationModal}
          closeMainModal={setShowModal}
          rowData={{ rowData }}
        />
      </>
    )
  );
};
export default EditWaterSource;
